// USER
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'
export const LOGIN_FAILED = 'LOGIN_FAILED'

export const GET_ROOM = 'GET_ROOM'

export const UPDATE_CHECKIN = 'UPDATE_CHECKIN'